export default __webpack_public_path__ + "static/Passion-Painting-64e99c996f50dce0d744bea83b26baf3.webp";